const CTABox = ({ heading, explain, actionLabel, actionFunction }) => {
  return (
    <div className="cta-box same-color-3 same-color-border">
      <h3 className="highlight">{heading}</h3>
      <p>{explain}</p>
      <a
        className={`blueButton`}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          actionFunction();
        }}
      >
        {actionLabel}
      </a>
    </div>
  );
};

export default CTABox;


export const EmptyCTABox = ({ heading, explain, children, className = '' }) => {
  return (
    <div className={`cta-box same-color-3 same-color-border ${className}`}>
      <h3 className="highlight">{heading}</h3>
      {explain ? <p>{explain}</p> : ""}
      {children}
    </div>
  );
};
